import React from "react"
import { navigate } from "gatsby"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"

const Wrapper = styled(Box)`
  button.learn-more-btn {
    //font-size: 12px;
  }

  border-radius: 4px;
  background: #dce8ea;

  padding: 16px 16px;

  @media (min-width: 768px) {
    padding: 8px 16px;
  }
`

const Title = styled(Box)``

const ProductWrapper = styled(Flex)`
  gap: 16px;
  align-items: center;
`

const DuoUpsell = ({ data }) => {
  const { title, product, button } = data

  const onUpsellClick = () => {
    segmentEvent("Marketing CTA Clicked", {
      module_location: "mid_fold",
      destination: button.path,
      text: button.label,
    })
    navigate(button.path)
  }

  return (
    <Wrapper>
      <Title>
        <TextElementMen
          element="h3"
          text={title}
          className="upsell-title body--large-b text-master-base-default"
        />
      </Title>
      <ProductWrapper>
        <Box width={[80, 80, 62, 80]}>
          <img src={product.image} alt={product.imageAlt} />
        </Box>
        <Box flex={1}>
          <TextElementMen
            text={product.name}
            className="body--regular text-master-base-black mb-2.5"
          />
          <ButtonWildMen
            label={button.label}
            textLink
            className="learn-more-btn"
            onClick={onUpsellClick}
          />
        </Box>
      </ProductWrapper>
    </Wrapper>
  )
}

export default DuoUpsell
